import Immutable from 'seamless-immutable';
import { FinancialActions } from '../actions';

const initialState = Immutable({
  dataPaginated: null,
  dataDetails: null,
});

export default function simulation(
  state = initialState,
  action,
) {
  switch (action.type) {
    case FinancialActions.ACTION_GET_SIMULATIONS:
      state = {
        ...state,
        dataPaginated: action.payload,
      };
      return state;
    default:
      return state;
  }
}

export function getDataPaginated(state) {
  return state.simulation.dataPaginated;
}